import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.sync()
  }

  sync() {
    const isOpen = this.element.open
    this.buttonTarget.setAttribute("aria-expanded", String(isOpen))
    this.buttonTarget.setAttribute("aria-label", isOpen ? "Close owner navigation" : "Open owner navigation")
  }

  closeOutside(event) {
    if (!this.element.open || this.element.contains(event.target)) return

    this.close()
  }

  close(event) {
    if (!this.element.open) return

    event?.preventDefault()
    this.element.open = false
    this.sync()
  }
}
